import type { ColumnsType } from 'antd/es/table';
import { Table, Typography } from 'antd';
import { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { PlayerLevelBaslineMetrics } from './baseline_util.js'

const { Text } = Typography

export const ThirdStep = ({ baselines }: IThirdStep) => {
    const { metrics } = useSelector(({ team }) => team)
    const [data, setData] = useState<DataType[]>([])

    const allMetrics = useMemo(
        () => ([...(metrics || []), ...PlayerLevelBaslineMetrics]),
        [metrics]
    );

    useEffect(() => {
        const metricKeyToMetricMapping: { [key: string]: string } = {}
        allMetrics.forEach((metric: any) => {
            metricKeyToMetricMapping[metric.key] = metric.name
        })

        setData(Object.entries(baselines).map((e) => {
            const [key, val] = e

            if (val === undefined || val === null || val === '') {
                return undefined
            }

            return {
                name: metricKeyToMetricMapping[key],
                key: key,
                value: val
            }
        }).filter((e) => e !== undefined))
    }, [])

    const tableColumns: ColumnsType<DataType> = [
        {
            title: 'Metric Name',
            dataIndex: 'name',
            key: 'name',
            render: (text) => (
                <div style={{ textAlign: 'left' }}>
                    <Text>{text}</Text>
                </div>
            ),
        },
        {
            title: 'Baseline',
            dataIndex: 'value',
            key: 'value',
            width: 100
        },
    ]

    return (
        <div style={{ marginBottom: '20px', width: "400px" }}>
            <Table className="compact-table" columns={tableColumns} dataSource={data} pagination={false} scroll={{ y: 300 }} size="small" />
        </div>
    )
}

interface IThirdStep {
    baselines: { [key: string]: number | string }
}

type DataType = {
    name: string,
    key: string,
    value: string | number
}

export default ThirdStep